import { render } from "./PosterSelect.vue?vue&type=template&id=61930928&scoped=true"
import script from "./PosterSelect.vue?vue&type=script&lang=js"
export * from "./PosterSelect.vue?vue&type=script&lang=js"

import "./PosterSelect.vue?vue&type=style&index=0&id=61930928&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61930928"]])

export default __exports__